import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Flex, Stack, Text, Title } from '@mantine/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { If } from '../If';

export interface EmptyContentViewProps {
  buttonLabel?: string;
  buttonLeftSection?: React.ReactNode;
  buttonVisible?: boolean;
  className?: string;
  dataTestId?: string;
  description?: string;
  icon?: React.ReactNode;
  onClick?: VoidFunction;
  title: string;
  textColor?: string;
  fontWeight?: React.CSSProperties['fontWeight'];
}

export function EmptyContentView({
  buttonLabel,
  buttonLeftSection,
  buttonVisible = true,
  className,
  dataTestId = 'section-empty-content-view',
  description,
  icon,
  onClick,
  title,
  textColor,
  fontWeight = 'bold',
}: EmptyContentViewProps) {
  const { t } = useTranslation();

  return (
    <Flex align="center" justify="center" direction="column" className={className} data-testid={dataTestId}>
      <Stack align="center">
        {icon}

        <If value={!!title}>
          <Title order={3} fw={fontWeight} fz={16} lh="24px" mt={icon ? 20 : 0} mb={0} c={textColor}>
            {title}
          </Title>
        </If>
        <If value={!!description}>
          <Text fz={14} mb={10} ta="center" c={textColor}>
            {description}
          </Text>
        </If>
        <If value={buttonVisible}>
          <Button
            data-testid="button-empty-content-add"
            leftSection={buttonLeftSection || <FontAwesomeIcon icon={faPlus} />}
            size="sm"
            onClick={onClick}
            miw={95}
            mt={10}
          >
            {buttonLabel || t('add')}
          </Button>
        </If>
      </Stack>
    </Flex>
  );
}
